import React from "react";
import { NavLink } from "react-router-dom";
import { BookMarked, Sparkles, MessageSquareText, LineChart, Building2, House, ListChecks } from "lucide-react";

const tabClass = ({ isActive }) =>
  "px-3 py-1.5 rounded-full font-mono text-[11px] uppercase tracking-wider border transition-colors duration-150 " +
  (isActive
    ? "bg-ledger-ink text-white border-ledger-ink"
    : "bg-white text-ledger-sub border-ledger-border hover:border-ledger-ink hover:text-ledger-ink");

export const TopBar = ({ onOpenPaste }) => {
  return (
    <header
      data-testid="top-bar"
      className="sticky top-0 z-40 border-b border-ledger-border backdrop-blur-xl"
      style={{ backgroundColor: "rgba(249,249,248,0.85)" }}
    >
      <div className="mx-auto max-w-[1700px] px-6 md:px-12 py-3 md:py-4 flex items-center justify-between gap-4">
        <NavLink to="/app" className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-sm bg-ledger-ink text-white grid place-items-center">
            <BookMarked className="h-4 w-4" />
          </div>
          <div className="leading-none">
            <div className="font-display text-xl text-ledger-ink" data-testid="app-title">
              Commitment Ledger
            </div>
            <div className="hidden sm:block text-[10px] uppercase tracking-[0.16em] text-ledger-muted mt-1">
              Living, evidence-backed client commitments
            </div>
          </div>
        </NavLink>

        <nav className="hidden lg:flex items-center gap-2">
          <NavLink to="/app" end className={tabClass} data-testid="nav-home">
            <span className="inline-flex items-center gap-1.5"><House className="h-3 w-3" /> Home</span>
          </NavLink>
          <NavLink to="/app/commitments" className={tabClass} data-testid="nav-commitments">
            <span className="inline-flex items-center gap-1.5"><ListChecks className="h-3 w-3" /> Commitments</span>
          </NavLink>
          <NavLink to="/app/conversations" className={tabClass} data-testid="nav-conversations">
            <span className="inline-flex items-center gap-1.5"><MessageSquareText className="h-3 w-3" /> Conversations</span>
          </NavLink>
          <NavLink to="/app/clients" className={tabClass} data-testid="nav-clients">
            <span className="inline-flex items-center gap-1.5"><Building2 className="h-3 w-3" /> Clients</span>
          </NavLink>
          <NavLink to="/app/impact" className={tabClass} data-testid="nav-impact">
            <span className="inline-flex items-center gap-1.5"><LineChart className="h-3 w-3" /> Impact</span>
          </NavLink>
        </nav>

        <button
          data-testid="cta-new-conversation"
          onClick={onOpenPaste}
          className="group inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ledger-ink text-white text-sm font-medium hover:bg-neutral-800 transition-colors duration-200"
        >
          <Sparkles className="h-4 w-4 group-hover:rotate-12 transition-transform duration-200" />
          Analyze conversation
        </button>
      </div>
      <nav className="lg:hidden overflow-x-auto border-t border-ledger-border px-4 py-2 flex items-center gap-2" aria-label="Primary navigation">
        <NavLink to="/app" end className={tabClass} data-testid="mobile-nav-home">Home</NavLink>
        <NavLink to="/app/commitments" className={tabClass} data-testid="mobile-nav-commitments">Commitments</NavLink>
        <NavLink to="/app/conversations" className={tabClass} data-testid="mobile-nav-conversations">Conversations</NavLink>
        <NavLink to="/app/clients" className={tabClass} data-testid="mobile-nav-clients">Clients</NavLink>
        <NavLink to="/app/impact" className={tabClass} data-testid="mobile-nav-impact">Impact</NavLink>
      </nav>
    </header>
  );
};
